export enum FileType {
    Images = 1,
    Attachments = 2,
    Invoices = 3,
    Logo = 4,
};

export enum VersionStatusType {
    Draft = "Draft",
    Published = "Published",
};

export enum PageType {
    CmsContent = "dynamic page",
    Static = "static page",
};

export enum ConnectionType {
    Primary = "Primary",
    Secondary = "Secondary",
};

export enum ExternalDataType {
    Json = "Json",
    Xml = "Xml",
    Database = "Database",
    File = "File",
};

export enum SubmittedFormStatus {
    NewSubmission = "New Form Submitted",
    Processed = "Processed",
};

export enum ContactMethods {
    MobilePhone = 1,
    Telephone = 2,
    Email = 3,
    Postal = 4,
    Fax = 5,
};

export enum UserStatus {
    UnVerified = 1,
    Active = 2,
    Blocked = 100,
    InvitationSent = 90,
    InvitationRejected = 91,
    InvitationAccepted = 92,
};

export enum UserType {
    Subscriber = 0,
    SiteOwner = 1,
    SiteAdmin = 2,
    SiteWriter = 3,
    SitePublisher = 4,
    SystemAdmin = 5,
};

export namespace UserType {
  export const getEnumDescription = (type: UserType) : string => {
    let desc: string = "Unknown";
    switch(type) {
      case UserType.Subscriber:
        desc = "Site Subscriber";
        break;
      case UserType.SiteOwner:
        desc = "Site Owner";
        break;
      case UserType.SiteAdmin:
        desc = "Site Administrator";
        break;
      case UserType.SiteWriter:
        desc = "Site Content Writer";
        break;
      case UserType.SitePublisher:
        desc = "Site Content Publisher";
        break;
      case UserType.SystemAdmin:
        desc = "System Administrator";
        break;
    }
    return desc;
  }
};

export enum SystemUserType {
    Site = 1,
    Subscriber = 2,
    Both = 3,
};

export namespace SystemUserType {
  const getEnumDescription = (type: SystemUserType) : string => {
    let desc: string = "Unknown";
    switch(type) {
      case SystemUserType.Subscriber:
        desc = "Subscriber Account";
        break;
      case SystemUserType.Site:
        desc = "Site User Account";
        break;
      case SystemUserType.Both:
        desc = "Site User And Subscriber Account";
        break;
    }
    return desc;
  }
};

export enum AccountType {
    Paid = 1,
    Complimentary = 2,
};

export namespace AccountType {
   const getEnumDescription = (type: AccountType) : string => {
    let desc: string = "Unknown";

    switch (type) {
      case AccountType.Paid:
        desc = "Standard Paid Account";
        break;
      case AccountType.Complimentary:
        desc = "Complimentary Account";
        break;
    }
    return desc;
  }
};

export enum AccountStatus {
    Normal = 1,
    ApproachingPaymentDue = 2,
    Overdue = 3,
    Suspended = 4,
    Cancelled = 5,
    Deleted = 999,
};

export enum PaymentFrequency {
    Annual = 1,
    Monthly = 2,
};

export enum PaymentRecordStatus {
    Pending = 1,
    Processing = 2,
    Completed = 3,
    Failed = 4,
    Cancelled = 5,
    Expired = 6
};

export enum DefaultTitlePrefix {
    Undisclosed = 1,
    Mr = 2,
    Mrs = 3,
    Ms = 4,
    Dr = 5,
};

export enum DefaultCountries {
    Unknown = 1,
};

export enum VersionStatus {
    Draft = 0,
    Published = 1
};

export enum LinkTargets {
    SameTab = "_self",
    NewWindow = "_blank",
    ParentWindow = "_parent",
    TopWindow = "_top"
};

export enum MenuAlignment {
    Left = "left",
    Right = "right"
};

export enum SystemEmailTemplates {
    SiteUserSignUp = 1,
    SiteUserSignUpThirdParty = 2,
    PasswordChangeRequest = 3,
    PasswordChangeSuccess = 4,
    SiteUserAdded = 5,
    SubscriptionReminder = 6,
    SubscriptionInvoice = 7,
    SubscriptionExpired = 8,
    SubscriptionCancelled = 9,
    SubscriptionPaymentReceipt = 10,
    NewsLetter = 11,
    SystemNotifications = 12,
    NewSubscriberSignUp = 13,
    NewSubscriberSignUpThirdParty = 14,
    ClientCancelAccount = 15,
    SiteAddedSubscriber = 16,
};

export enum ScriptIncludeType {
    Css = 1,
    ClientScript = 2,
    Robots = 3,
    AI = 4
};

export enum NewsletterStatus {
    Unsent = 1,
    Sent = 2,
};

export enum TemplateType {
    ColumnsFW = "ColumnsFullWidth",
    ColumnsCC = "Columns",
    ContentFW = "FullWidthContent",
    ContentCC = "CenteredContent"
};

// Helper function to mimic C# enum description behavior
export function getEnumDescription<T>(enumType: T, value: keyof T): string {
    const enumDescriptions: { [key: string]: string } = {
        CmsContent: "dynamic page",
        Static: "static page",
        Draft: "Draft",
        Published: "Published",
        NewSubmission: "New Form Submitted",
        Processed: "Processed",
        Json: "Json",
        Xml: "Xml",
        Database: "Database",
        File: "File",
    };

    // Cast value to string to safely access enumDescriptions
    return enumDescriptions[value as string] || (value as string);
};

export enum ShareTo {
  Facebook = 1,
  X = 2,
  Google = 3,
  Instagram = 4
};

// Helper function to return all values in an enum
export function getEnumElements<T extends object>(enumType: T): (T[keyof T])[] {
    return Object.keys(enumType)
      .filter(key => isNaN(Number(key)))  // Filter out numeric keys (which are reverse mappings in enums)
      .map(key => enumType[key as keyof T]);
};

export enum TreeItemSort {
  Unsorted = 1,
  Ascending = 2,
  Descending = 3
};

export enum BusinessAccountOptions {
  Basic = 1,
  ContentManagement = 2,
  MediaLibrary = 3,
  CustomDomain = 4,
  AdvancedSEO = 5,
  NewsAndBlog = 6
};
